module.exports = __webpack_public_path__ + "src/assets/img/login-form-bg.png";